/*
 * @Author: huangzq
 * @Date: 2019-12-17 17:17:38
 * @Last Modified by: huangzq
 * @Last Modified time: 2020-07-27 11:53:42
 * @Desc: 选择表单类型
*/
<template>
  <div class="select">
    <div class="content">
      <div class="title-wrapper">
        <p class="title">
          请选择表单类型
        </p>
        <i
          class="icon iconfont icon-mk-guanbi"
          @click="cancel"
        />
      </div>
      <div class="radio-group-wrapper">
        <mk-radio-group v-model="activeRadio">
          <mk-radio
            v-for="item in radioGroup"
            :key="item.label"
            :label="item.label"
          >
            {{ item.name }}
          </mk-radio>
        </mk-radio-group>
      </div>

      <div class="btn-group">
        <mk-button-biz
          width="64px"
          font-size="13px"
          @click="cancel"
        >
          取消
        </mk-button-biz>
        <mk-button-biz
          type="primary"
          width="64px"
          font-size="13px"
          @click="confirm"
        >
          确认
        </mk-button-biz>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      activeRadio: 'mini',
      radioGroup: [
        {
          name: '小程序表单',
          label: 'mini'
        },
        {
          name: 'H5表单',
          label: 'h5'
        }
      ]
    }
  },
  methods: {
    cancel () {
      this.$emit('cancel')
    },
    confirm () {
      this.$emit('confirm', this.activeRadio)
    }
  }
}
</script>
<style lang="scss" scoped>
.select {
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;

  .content {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 350px;
    border-radius: 4px;
    background-color: #fff;

    .title-wrapper {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 54px;
      padding: 0 20px;
      box-shadow: 0 -1px 0 0 #e8e8e8 inset;

      .title {
        font-size: 14px;
        color: #262626;
      }

      .icon {
        font-size: 14px;
        color: #bfbfbf;
        cursor: pointer;
      }
    }

    .radio-group-wrapper {
      margin: 20px;

      & /deep/ .mk-radio-group {
        display: flex;
        justify-content: space-around;
      }
    }

    .btn-group {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 54px;
      border-top: 1px solid rgba(0, 0, 0, 0.09);
    }
  }
}
</style>
